var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAssessmentStatusPending(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.82 3H18C19.1 3 20 3.9 20 5V10.68C19.38 10.39 18.71 10.18 18 10.08V5H16V6C16 7.1 15.1 8 14 8H10C8.9 8 8 7.1 8 6V5H6V20H10.69C11.04 20.75 11.52 21.43 12.11 22H6C4.9 22 4 21.1 4 20V5C4 3.9 4.9 3 6 3H9.18C9.6 1.84 10.7 1 12 1C13.3 1 14.4 1.84 14.82 3ZM11 4C11 4.55 11.45 5 12 5C12.55 5 13 4.55 13 4C13 3.45 12.55 3 12 3C11.45 3 11 3.45 11 4ZM12 17C12 14.24 14.24 12 17 12C19.76 12 22 14.24 22 17C22 19.76 19.76 22 17 22C14.24 22 12 19.76 12 17ZM16.5 19C16.5 19.275 16.725 19.5 17 19.5C17.275 19.5 17.5 19.275 17.5 19V17C17.5 16.725 17.275 16.5 17 16.5C16.725 16.5 16.5 16.725 16.5 17V19ZM16.5 15.5H17.5V14.5H16.5V15.5Z",
    fill: "#FFB300"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessmentStatusPending);
export default __webpack_public_path__ + "static/media/assessment_status_pending.55f30364.svg";
export { ForwardRef as ReactComponent };